<template>
  <v-menu offset-y>
    <template #activator="{ on }">
      <v-text-field
        :value="value | formattedDate"
        :label="label"
        readonly
        outlined
        hide-details
        solo
        class="date-calendar-field"
        v-on="on"
      >
        <template #append>
          <calendar-icon class="calendar-range-icon" />
        </template>
      </v-text-field>
    </template>
    <v-card class="date-calendar-field-date-picker-wrapper">
      <v-date-picker
        :value="value"
        width="284"
        no-title
        color="icon-brand"
        class="date-calendar-field-date-picker"
        :locale="datePickerLocale"
        :max="nowDate"
        :month-format="month => month.toUpperCase()"
        @input="changeDate"
      />
    </v-card>
  </v-menu>
</template>

<script>
import moment from 'moment/moment'
import datePickerCurrentLanguage from '@/mixins/datePickerCurrentLanguage'
import CalendarIcon from '@/assets/svgIcons/calendarOutlined.svg?inline'

export default {
  name: 'DateRangeCalendarField',
  components: { CalendarIcon },
  filters: {
    formattedDate (date) {
      return date ? moment(date).format('DD.MM.YYYY') : ''
    }
  },
  mixins: [datePickerCurrentLanguage],
  props: ['value', 'label'],
  computed: {
    nowDate () {
      return new Date().toISOString().slice(0,10)
    }
  },
  methods: {
    changeDate (value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="scss">
.date-calendar-field {
  max-width: 170px;
  width: 170px;
  height: 40px;

  &.v-text-field.v-text-field--solo .v-input__control {
    max-height: 100%;
    min-height: unset;
  }

  &.v-text-field--outlined.v-input--is-focused > .v-input__control > .v-input__slot,
  &.v-text-field--outlined.v-input--is-focused.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    fieldset {
      border: 1px solid var(--v-input-border-focused-base);
    }
  }

  &.v-text-field--outlined > .v-input__control > .v-input__slot,
  &.v-text-field--outlined.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    min-height: unset;
    height: 40px;
    cursor: auto;
    border-radius: 8px;
    box-shadow: unset;

    fieldset {
      border-radius: 8px;
      border: 1px solid var(--v-input-border-default-base);
    }

    input {
      display: flex;
      align-items: center;
      height: 100%;
      top: 0;
      color: var(--v-input-foreground-typed-base);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }

    .v-input__append-inner {
      margin: auto 0;
    }
  }

  .calendar-range-icon {
    width: 20px;
    height: 20px;
    color: var(--v-input-foreground-typed-base);
  }
}

.date-calendar-field-date-picker-wrapper.v-sheet.v-card {
  border-radius: 8px;

  .v-date-picker-header__value button:hover {
    color: var(--v-text-primary-base)!important;
  }

  .date-calendar-field-date-picker {
    .icon-brand--text {
      color: var(--v-text-primary-base);
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      letter-spacing: 0.5px;
    }
  }
}
</style>
